import React, { useEffect, useState } from 'react'
import { InputText } from 'primereact/inputtext';
import { Panel } from 'primereact/panel';
import { Sidebar } from 'primereact/sidebar';

import useCensus from '../../hooks/useCensus';
import  useTreeTemplateServices  from '../../hooks/useTreeTemplateServices';
import useFormModelServices from '../../hooks/useFormModelServices';
import useFormServices from '../../hooks/useFormServices';
import { useLocationServices } from '../../hooks/useLocationServices';
import {useHierarchyService} from '../../hooks/useHierarchyService';
import { useDialogService } from '../../hooks/useDialogService';

import { GetClientOrDependentName } from '../../utilities/Helper';
import { GetStartOfDay,  GetISODate, FormattedDateString } from '../../utilities/DateHelper';
import { Severity } from '../../constants/ProConstants';

import ProCensusForm from '../../components/census/ProCensusForm';
import ProCalendar from '../../components/common/ProCalendar';
import ProTreeTable from '../../components/common/ProTreeTable';
import ProCensusFilter from '../../components/census/ProCensusFilter';
import ProViewBedDetailsForm from '../../components/census/ProViewBedDetailsForm';
import ProBedHistory from '../../components/census/ProBedHistory';
import ProClientHistory from '../../components/census/ProClientHistory';
import ProMultiSelect from '../../components/common/ProMultiSelect';
import ProClientMedicationDetails from '../../components/census/ProClientMedicationDetails';
import ProClientAllergyDetails from '../../components/census/ProClientAllergyDetails'

import _ from 'lodash'

import "../../components/census/census.css"
import "../../pages/DashBoard.css"



const Census = () => {  
   
    const [showFilter, setShowFilter] = useState(false);   
    const [toggleSideBar, setToggleSideBar] = useState(false);   
    const [formAction, setFormAction] = useState("");
    const [formModel, setFormModel] = useState(null);
    const [searchValue, setSearchValue] = useState("");
    const [formHeader, setFormHeader] = useState("");
    const [formOrientation, setFormOrientation] = useState('right')

    const { data:{tree},actions:{ParseHierarchy}} =  useHierarchyService()
    const { locations, isLocationsInitialized, primaryLocationId } = useLocationServices();
    const { GetCensusModel, GetDetails } = useFormModelServices();
    const { data:{ filter, isFilterApplied, selectedLocations, defaultExpandedKeys }, 
            actions:{InitializeDefaults, SetSelectedLocations, SetSelectedDate, RemoveAssignOrReserve } } = useCensus({ refreshTree: true });
    const {actions:{ShowDialog}} = useDialogService();
    const {actions:{ UpdateFormState}} = useFormServices();
   
    useEffect(() => {       
        if (_.get(locations, "length") > 0) {
            if(_.isNull(selectedLocations)){                
                InitializeDefaults(_.isNull(filter.date)?GetISODate(GetStartOfDay()) : filter.date,  locations)   
            }       
           
        }
    }, [InitializeDefaults, selectedLocations, locations, primaryLocationId, filter])

    useEffect(()=>{
        return ()=>{  
            UpdateFormState(false)                   
        }
    }, [])


   

   const performAction = async (node, assignmentData, action, formTitle, orientation ='right') => { 
        setToggleSideBar(false); 
        ParseHierarchy();
        setFormOrientation(orientation)      
        let data =  _.includes(["VIEW_BED", "BED_HISTORY", "CLIENT_HISTORY", "CLIENT_MEDICATION", "CLIENT_ALLERGY"], action)?await GetDetails(node, filter.date, assignmentData, action) : await GetCensusModel(assignmentData, action);
       
        switch(action){
            case "ASSIGN":
            case "RESERVE":
            case "VIEW_BED":
            case "MOVE": 
            case "EDIT_ASSIGN":
            case "BED_HISTORY":
            case "CLIENT_HISTORY":
            case "CLIENT_ALLERGY":
            case "CLIENT_MEDICATION":
                setFormModel(data);
                setFormHeader(formTitle)
                setFormAction(action);
                setToggleSideBar(true);
                break;  
            case "REMOVE_ASSIGN":
            case "REMOVE_RESERVE":
                data = {...data, date:FormattedDateString(filter.date), action:"CANCEL"}                
                var header =   _.isEqual(action, "REMOVE_RESERVE")?`Remove reservation for ${GetClientOrDependentName(data)}?`
                :`Remove bed assignment for ${GetClientOrDependentName(data)}?` 
                var labelOk = _.isEqual(action, "REMOVE_RESERVE")? "Yes, Remove Reservation":"Yes, Remove Assignment";
                var labelCancel = "Cancel";               
                await ShowDialog(header, null, null, labelOk, labelCancel, Severity.Danger,
                    async ()=>{
                        await  RemoveAssignOrReserve(data); 
                    },
                    ()=>{
                        console.log("Cancelled");
                    }  )
                break;             
            default:
            break;
        }
       
    }
  
   
    const {data:{CensusTableConfig}, actions :{OnTreeNodeSelect}} = useTreeTemplateServices({performAction, activePage:"CENSUS"}); 

    return (<div>
        <div className='header-row'>           
            <div className="search-box">
                <span className="p-input-icon-left">
                    <i className="pi pi-search" />
                    <InputText className='search-bar-input' onChange={(e) => setSearchValue(e.target.value)} placeholder="Search" />
                </span>
            </div>
            <div>
                <ProMultiSelect value={selectedLocations} options={locations} onChange={SetSelectedLocations}/>
            </div>
            <div className='header-filter-box' onClick={() => setShowFilter(prev => !prev)}>
                <span style={{ marginRight: "5px" }}> Filter</span>
                {isFilterApplied && <i className="fa fa-filter margin-top-4"></i>}
                {!isFilterApplied && <i className="fal fa-filter margin-top-4"></i>}
            </div>
            <div className='census-calendar' >
                <ProCalendar id="censusDate"
                    placeholder="Date"
                    value={filter.date}
                    onChange={(e)=>SetSelectedDate( GetISODate(e.value))}
                    style={{ width: "100%", marginBottom: "2px", height: "40px" }}                    
                    required />
            </div>
        </div>
        {showFilter && <div className="p-col-16 p-lg-12">
            <Panel header="Filter Options">
                <ProCensusFilter toggleFilter={()=>setShowFilter(prev => !prev)} />
            </Panel>
        </div>}
        <div>
           {_.isEqual(formOrientation, 'right') && <Sidebar dismissable={false} modal={false}
                visible={toggleSideBar} position={formOrientation}
                style={_.isEqual(formOrientation, 'right')?{ width: '30em' }:{minHeight: '20em'}} onHide={() => setToggleSideBar(false)} icons={() => (
                    <h6 className="p-sidebar-close"
                        style={{ fontWeight: '700', fontSize: '20px', width: '100%', margin: 'auto' }}>{formHeader}</h6>
                )}>               
               {(!_.includes(["VIEW_BED", "BED_HISTORY", "CLIENT_HISTORY", "CLIENT_ALLERGY", "CLIENT_MEDICATION"], formAction)) && <ProCensusForm formModel={formModel} formAction={formAction} closeSideBar={(e) => setToggleSideBar(false)} />}
               {_.isEqual(formAction, "VIEW_BED") && <ProViewBedDetailsForm formModel={formModel}  closeSideBar={(e) => setToggleSideBar(false)} />}               
            </Sidebar>
            }
            
           {_.isEqual(formOrientation, 'bottom') && <Sidebar dismissable={false} modal={false}
                visible={toggleSideBar} position={formOrientation}
                style={_.isEqual(formOrientation, 'right')?{ width: '30em' }:{minHeight: '20em'}} onHide={() => setToggleSideBar(false)} icons={() => (
                    <h6 className="p-sidebar-close"
                        style={{ fontWeight: '700', fontSize: '20px', margin: 'auto',width:'100%'}}>{formHeader}</h6>
                )}>               
              
               {_.isEqual(formAction, "BED_HISTORY") && <ProBedHistory formModel = {formModel}  closeSideBar={(e) => setToggleSideBar(false)} />}
               {_.isEqual(formAction, "CLIENT_HISTORY") && <ProClientHistory formModel = {formModel}  closeSideBar={(e) => setToggleSideBar(false)} />}
               {_.isEqual(formAction, "CLIENT_MEDICATION") && <ProClientMedicationDetails formModel={formModel} closeSideBar={(e)=>setToggleSideBar(false)}/>}
               {_.isEqual(formAction, "CLIENT_ALLERGY") && <ProClientAllergyDetails formModel = {formModel} closeSideBar = {(e)=> setToggleSideBar(false)}/>}

            </Sidebar>
            }
        </div>
        <div>
            <div className='data-row'>                
                <div className="p-col-16 p-lg-12">
                    {(tree && tree.length > 0) && <ProTreeTable index={0} treeData={tree} defaultSelectionKey={tree[0].key} defaultExpandedKeys={defaultExpandedKeys} isFilterApplied={isFilterApplied} searchValue={searchValue} config={CensusTableConfig} OnTreeNodeSelect={OnTreeNodeSelect}  />}

                    {(isLocationsInitialized && _.get(selectedLocations, "length") === 0) && <div>No Records found</div>}
                </div>
            </div>
        </div>       
    </div>

    )
}

export default Census;